/**
 * "Description" step for Create SIX flow.
 * Allows optional short description with character count.
 */
import React from 'react';
import { Button, Col, Container, Row, Form } from 'shared-portal-component';
import { z } from 'zod';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '@/store';
import { setDraftField, setStep } from '@/store/slices/createSix/createSixSlice';
import { selectDraft } from '@/store/selectors/createSix';

interface StepDescriptionProps {
  onClose: () => void;
}

const MAX_LENGTH = 256;

const schema = z.object({
  description: z.string().max(MAX_LENGTH, `Must be at most ${MAX_LENGTH} characters`),
});

const StepDescription: React.FC<StepDescriptionProps> = () => {
  const dispatch = useAppDispatch();
  const draft = useSelector(selectDraft);

  // Form fields config
  const fields = [
    {
      name: 'description',
      label: '',
      type: 'textarea',
      title: (
        <>
          Do you want to give your SIX a short description?
          <br />
          You can also leave this field blank.
        </>
      ),
      required: false,
    },
  ];

  // Submit handler
  const handleSubmit = (values: { description: string }) => {
    dispatch(setDraftField({ key: 'description', value: values.description }));
    dispatch(setStep('Owners'));
  };

  // Back handler
  const handleBack = () => dispatch(setStep('Name'));

  return (
    <Container fluid>
      <Row spacing="md" justify="center">
        <Col md={7} sm={10} xs={12}>
          <Form
            schema={schema}
            fields={fields}
            onSubmit={handleSubmit}
              defaultValues={{
              description: draft.description,
            }}
            secondaryButton={
              <Button
                text="Go Back"
                variant="primary"
                onClick={handleBack}
                size="md"
                className="form-button"
              />
            }
          />
        </Col>
      </Row>
    </Container>
  );
};

export default StepDescription;
